// 마이크로 스트립 — 8px 스택 바 + 범례 (시안 .strip/.legend). 파이프라인 분포 등.
// props: segments:[{label, count, color, onClick, title}], total (없으면 count 합), legend:true
// hover 툴팁 — 바 조각·범례 항목 둘 다 title. 세그가 title 을 주면 그것을(분포 카드는 'N대 (P%)'),
// 안 주면 기본 '라벨 N' (말소 진행 스텝 스트립처럼 단위·비율이 뜻 없는 곳).
import React from 'react';
import { T, NUM } from '../theme';

var bar = { display: 'flex', height: 8, borderRadius: 999, overflow: 'hidden', background: T.track };
var legendSt = { display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 8 };
var itemSt = Object.assign({ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11.5, color: T.dim, background: 'none', border: 'none', padding: 0, fontFamily: 'inherit' }, NUM);

function MicroStrip(props) {
  var segs = props.segments || [];
  var total = props.total != null ? props.total : segs.reduce(function (s, x) { return s + (Number(x.count) || 0); }, 0);
  var tip = function (s, c) { return s.title || (s.label + ' ' + c); };
  return (<div>
    <div style={bar}>
      {segs.map(function (s, i) {
        var c = Number(s.count) || 0;
        if (!c || !total) return null;
        return <i key={s.id || s.label || i} title={tip(s, c)} onClick={s.onClick}
          style={{ display: 'block', height: '100%', width: (c / total * 100) + '%', background: s.color || T.muted, cursor: s.onClick ? 'pointer' : undefined }} />;
      })}
    </div>
    {props.legend ? <div style={legendSt}>
      {segs.map(function (s, i) {
        return (<button key={s.id || s.label || i} type="button" onClick={s.onClick} title={tip(s, Number(s.count) || 0)}
          style={Object.assign({}, itemSt, { cursor: s.onClick ? 'pointer' : 'default' })}>
          <i style={{ width: 8, height: 8, borderRadius: 2, display: 'inline-block', background: s.color || T.muted }} />
          {s.label} <b style={{ color: T.ink }}>{Number(s.count) || 0}</b>
        </button>);
      })}
    </div> : null}
  </div>);
}

export default MicroStrip;
